module.exports = __webpack_public_path__ + "img/ca-logo-new-72x72-white.5512998c.png";